import { Box } from '@mui/material';
import { motion, useReducedMotion } from 'framer-motion';
import { PropsWithChildren } from 'react';

import { pageSlideVariants } from './framer-variants';

export const PageSlideAnimation = (props: PropsWithChildren) => {
  const shouldReduceMotion = useReducedMotion();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100vw',
        height: ['100dvh', '100vh'],
        overflow: 'hidden',
        position: 'absolute',
        top: 0,
      }}
    >
      {!shouldReduceMotion && (
        <motion.div
          className="Page"
          custom={{ direction: 'up' }}
          initial="initial"
          animate="in"
          exit="out"
          variants={pageSlideVariants}
          style={{
            width: '100vw',
            height: '100%',
          }}
        >
          {props.children}
        </motion.div>
      )}

      {shouldReduceMotion && <>{props.children}</>}
    </Box>
  );
};
